var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    { attrs: { name: "fade" } },
    [
      _vm.showModal
        ? _c(
            "Modal",
            {
              attrs: { snug: "" },
              on: {
                close: function ($event) {
                  _vm.showModal = false
                },
              },
            },
            [
              _c("div", { staticClass: "text-center" }, [
                _c(
                  "div",
                  { staticClass: "w-20 mx-auto mb-4" },
                  [_c("IconDelivery")],
                  1
                ),
                _vm._v(" "),
                _c("h3", { staticClass: "text-md mb-4" }, [
                  _vm._v("Thankyou for your order!"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "mb-4 md:mb-8 text-sm" }, [
                  _vm._v(
                    "\n        Yay, your order has been placed! You will receive a confirmation email\n        very shortly. We will get straight onto processing your order and will\n        have it delivered to you in the next few working days.\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "grid grid-cols-2 gap-x-4 gap-y-2" }, [
                  _c(
                    "button",
                    {
                      staticClass: "col-span-2 md:col-span-1 btn-soft px-2",
                      on: {
                        click: function ($event) {
                          _vm.showModal = false
                        },
                      },
                    },
                    [_vm._v("\n          Continue Shopping\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "col-span-2 md:col-span-1 btn-strong px-2",
                      attrs: {
                        href: `/shop/customer/order?number=${_vm.orderNumber}&success=true`,
                      },
                    },
                    [_vm._v("View My Order")]
                  ),
                ]),
                _vm._v(" "),
                _vm.orderHasTestPot
                  ? _c("div", { staticClass: "mt-4 md:mt-6" }, [
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.showTestPotQuestion,
                              expression: "!showTestPotQuestion",
                            },
                          ],
                          staticClass:
                            "link underline max-w-xs focus:outline-none",
                          on: {
                            click: function ($event) {
                              _vm.showTestPotQuestion = true
                            },
                          },
                        },
                        [
                          _vm._v(
                            "Can we ask you ONE question about your test pot purchase?"
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showTestPotQuestion,
                            expression: "showTestPotQuestion",
                          },
                        ],
                        staticClass: "testpot-hs-form",
                        attrs: { id: "hubspotForm" },
                      }),
                    ])
                  : _vm._e(),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }